export default __webpack_public_path__ + "static/media/emptyCart.f3eee176.svg";